import { colorPrimary400 } from './colors';
import { fontFamilyPrimary, fontFamilySecondary } from './fonts';

export const VARIANTS = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  BODY1: 'body1',
  BODY2: 'body2',
  BUTTON1: 'button1',
  BUTTON2: 'button2',
  LINK: 'link',
};

const createFont = (fs, lh, fw = 600) => ({
  fontSize: fs,
  lineHeight: `${lh}px`,
  fontWeight: fw,
});

export const typography = {
  [VARIANTS.H1]: {
    ...createFont(60, 72, 600),
    fontFamily: fontFamilySecondary,
    letterSpacing: '-0.02em',
  },
  [VARIANTS.H2]: {
    ...createFont(48, 56, 600),
    fontFamily: fontFamilySecondary,
    letterSpacing: '-0.02em',
  },
  [VARIANTS.H3]: {
    ...createFont(32, 40, 600),
    fontFamily: fontFamilySecondary,
    letterSpacing: '-0.02em',
  },
  [VARIANTS.H4]: {
    ...createFont(24, 32, 600),
    fontFamily: fontFamilySecondary,
    letterSpacing: '-0.03em',
  },
  [VARIANTS.H5]: {
    ...createFont(20, 28, 600),
    fontFamily: fontFamilySecondary,
    letterSpacing: '-0.02em',
  },
  [VARIANTS.H6]: {
    ...createFont(18, 24, 600),
    fontFamily: fontFamilySecondary,
    letterSpacing: '-0.02em',
  },
  [VARIANTS.BODY1]: {
    ...createFont(16, 28, 500),
    fontFamily: fontFamilyPrimary,
  },
  [VARIANTS.BODY2]: {
    ...createFont(14, 24, 500),
    fontFamily: fontFamilyPrimary,
  },
  [VARIANTS.BUTTON1]: {
    ...createFont(14, 24, 700),
    fontFamily: fontFamilySecondary,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    fontFeatureSettings: "'pnum' on, 'lnum' on",
  },
  [VARIANTS.BUTTON2]: {
    ...createFont(12, 16, 700),
    fontFamily: fontFamilySecondary,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    fontFeatureSettings: "'pnum' on, 'lnum' on",
  },
  [VARIANTS.LINK]: {
    ...createFont(14, 24, 500),
    fontFamily: fontFamilyPrimary,
    letterSpacing: '0.02em',
    cursor: 'pointer',
    textDecorationLine: 'underline',
    fontFeatureSettings: "'pnum' on, 'lnum' on",
    color: colorPrimary400,
  },
};
